function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 5.667)"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.5,
  id: "prefix__b",
  d: "M1.936.065c.176 0 .352.001.506.009.161.009.38-.061.593.453.22.529.748 1.827.813 1.959.066.132.11.286.022.462-.087.176-.13.286-.264.44-.132.154-.277.343-.395.462-.132.131-.269.274-.116.538.154.264.684 1.128 1.467 1.828 1.008.898 1.858 1.177 2.122 1.308.264.132.417.111.571-.065.153-.176.66-.771.835-1.034.176-.265.352-.221.593-.133.243.089 1.54.727 1.803.858.264.133.44.199.505.309.066.11.066.638-.153 1.254-.22.615-1.274 1.178-1.78 1.255-.455.067-1.03.095-1.663-.106a15.088 15.088 0 01-1.503-.555C3.246 8.164 1.52 5.5 1.387 5.324 1.255 5.148.31 3.895.31 2.596c0-1.298.682-1.937.924-2.2a.966.966 0 01.703-.331z"
})), /*#__PURE__*/React.createElement("path", {
  id: "prefix__d",
  d: "M9.182.107c7.19-1 13.263 5.16 12.103 12.378-.694 4.317-4.067 7.838-8.35 8.715-2.64.542-5.254.106-7.5-1.172l.012.006-3.348.961a1.286 1.286 0 01-1.622-1.477l.028-.116.929-3.211c.016-.055.006-.125-.036-.199C.133 13.77-.305 11.178.213 8.56 1.064 4.256 4.586.853 8.92.147l.263-.04zm10.128 12.06A8.724 8.724 0 009.24 2.121c-3.508.572-6.376 3.343-7.065 6.827-.424 2.143-.068 4.246.962 6.056.302.532.388 1.156.218 1.743l-.571 1.97 2.142-.614c.45-.13.922-.087 1.343.106l.155.08c1.83 1.041 3.95 1.395 6.11.952 3.468-.71 6.214-3.577 6.776-7.074z"
}));

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e0f45d4e.svg";
export { ForwardRef as ReactComponent };